import { createFileRoute, redirect } from '@tanstack/react-router'

// Former URL of the guarantees list, kept so old links and bookmarks still land on it.
export const Route = createFileRoute('/(redirects)/contract-guarantees')({
  beforeLoad: () => {
    throw redirect({ to: '/product-guarantees', replace: true })
  },
})
